import { h, Component } from 'preact';
import style from './style';

import { constants } from '../config';
import { getEngagements } from '../helper';

export default class OTTPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animate: false,
      fadeOut: false,
    }
    this.animationTimeout = null;
    this.count = 0;
  }
  componentDidMount() {
    const displayAdAnimation = this.props.json.meta && this.props.json.meta.display_ad_animation || [];
    const tagAni = displayAdAnimation.find(t => t.id === this.props.tag.id);
    const aniClass = this.animationClass(tagAni);
    if (aniClass.txt || aniClass.img) {
      this.setState({ animate: true }, () => {
        this.startAnimation();
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.animationTimeout);
  }

	render(props, state) {
    const displayAdAnimation = props.json.meta && props.json.meta.display_ad_animation || [];
    const tagAni = displayAdAnimation.find(t => t.id === props.tag.id);
    const aniClass = this.animationClass(tagAni);
    let image = this.getImage(props.tag, props.orientation);
    let engagement = props.tag && props.tag.settings.subcategory[0].engagements[0];
    let cta = engagement && engagement[`label|${engagement.slug}`];
    let previewImageAnimation = aniClass.img;
    if (previewImageAnimation) {
      previewImageAnimation += state.animate ? ' animate' : '';
    }
    let previewDetailsAnimation = aniClass.txt;
    if (previewDetailsAnimation) {
      previewDetailsAnimation += state.animate ? ' animate' : '';
    }
    return (
      <div class={`ottPreview ${state.fadeOut ? ' fadeOut' : ''}`} onClick={this.handleClickThrough}>
        <div class="previewImageWrapper">
          <div class={`previewImage ${previewImageAnimation}`} style={{
            background: `url(${image}) center center / contain no-repeat`,
          }} />
        </div>
        <div class={`previewDetails ${previewDetailsAnimation}`}>
          <div class={'previewTitle'} dangerouslySetInnerHTML={{__html: props.tag.details.title}} />
          <div
            class={'previewCTA'}
            onClick={props.unmount}
            style={{
              background: props.tag.details.color || '#1fbcf0'
            }}
            dangerouslySetInnerHTML={{ __html: cta }} />
        </div>
      </div>
    );
  }

  animationClass = (tagAni={}) => {
    const animate = { img: '', txt: '' };

    switch(tagAni.image_ani) {
      case 'Zoom':
        animate.img = 'ZOOM_IN';
        break;
      case 'Fade':
        animate.img = 'FADE_IN';
        break;
      case 'None':
      default:
        animate.img = '';
        break;
    }
    
    switch(tagAni.text_ani) {
      case 'MoveIn':
        animate.txt = 'MOVE_IN';
        break;
      case 'Fade':
        animate.txt = 'FADE_IN';
        break;
      case 'None':
      default:
        animate.txt = '';
        break;
    }

    return animate;
  }

  startAnimation = () => {
    this.count++;
    clearTimeout(this.animationTimeout);
    if (this.count > 2) return; 
    this.animationTimeout = setTimeout(() => {
      this.setState({ fadeOut: true }, () => {
        this.animationTimeout = setTimeout(() => {
          this.setState({ animate: false});
        }, 200);
        this.animationTimeout = setTimeout(() => {
          this.setState({ fadeOut: false, animate: true})
          this.startAnimation();
        }, 300);
      });
    }, 9000);
  }

  handleClickThrough = () => {
    if (this.props.displayAdClickThroughLink) {
      // Engagement event for display ad click & traffic---
      if (this.props.displayAdClickThroughLink.length > 0) {
        this.logEngagementEvent({ event_type: 'display-ad' });
      }
      //---
      this.props.displayAdClickThroughLink.forEach(link => {
        window.open(link);
      });
    }
  }

  getImageFromTag = (tag, orientation) => {
    let isLandscape = orientation === constants.ORIENTATION_LANDSCAPE;
    if (tag && tag.media && tag.media.images) {
      return tag && (isLandscape ?
              tag.media.images.img1_src :
              (typeof tag.media.images.img2_src !== 'undefined' ? tag.media.images.img2_src : tag.media.images.img1_src));
    }
  }

  getImage = (tag, orientation) => {
    if (tag) {
      let subcategory = tag && tag.settings.subcategory && tag.settings.subcategory[0];
      switch(tag.settings.category) {
        case 1:
        case 7:
        case 8:
        case 10:
        case 11:
        case 12:
        case 15:
        case 18:
        case 19:
        case 20:
          return this.getImageFromTag(tag, orientation);
        case 9:
          switch (subcategory.type) {
            case 900:
              let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
              let answers = engagement && engagement && engagement.answer;
              if (engagement && engagement.imagepoll) {
                return answers && answers[0].image;
              } else return this.getImageFromTag(tag, orientation);
            case 901:
            case 902:
            case 904:
            case 905:
            case 906: return this.getImageFromTag(tag, orientation);
          }
        case 14:
          switch (subcategory.type) {
            case 1402: return this.getImageFromTag(tag, orientation);
            case 1401:
            case 1403:
              let engagement = tag.details && tag.details.engagements && tag.details.engagements[0]
              let firstGallaryElem = engagement.meta && engagement.meta[0]
              if (firstGallaryElem) {
                return firstGallaryElem.cover_image_selected || firstGallaryElem.url;
              }
          }
        case 21: {
          switch (subcategory.type) {
            case 2104:
              let engagement = tag.details && tag.details.engagements && tag.details.engagements[0];
              let answers = engagement && engagement && engagement.answer;
              if (engagement && engagement.imagepoll) {
                return answers && answers[0].image;
              } else return this.getImageFromTag(tag, orientation);
            case 2101:
            case 2102:
            case 2103:
              return this.getImageFromTag(tag, orientation);
          }
        }
      }
    }
  }

  logEngagementEvent = (data) => {
    let engagements = getEngagements(this.props.tag);
    let action = engagements && engagements[0];
    let actionValueFormtted = data.event_type || action.slug;

    let tag_id = this.props.tag.id;
    let tag_label =
      this.props.tag &&
      this.props.tag.details &&
      (this.props.tag.details.preview_title || this.props.tag.details.title);
    let engagement_id = action && action.id;

    let options = {
      type: actionValueFormtted,
      sub_type: null,
      event: 'engagement',
      event_type: actionValueFormtted,
      tag_id,
      tag_label,
      engagement_id,
      engagement_type: 'out-video',
      current_duration: null
    };
    this.props.eventBus(constants.LOG_EVENT_ENGAGEMENT, {
      tag: this.props.tag,
      options
    });
  };
}



// WEBPACK FOOTER //
// ./components/ottPreview/index.js